module.exports = __webpack_public_path__ + "static/img/tiktok-icon.c28df8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiktok-icon.svg
// module id = 5u+D
// module chunks = 0